import Helper from "../../Helper";
import { MapObject } from "../../models/MapObject";
import { plotFetch } from "../Helper/ApiRequest";
import { ConvertibleMappableType } from "../Helper/MappableConversion";

export interface MappableConversionResult {
    mappableType?: ConvertibleMappableType;
    mappableId?: number;
    error?: string;
}

export function convertMappable(
    team_subdomain: string,
    project_token: string,
    mappableType: ConvertibleMappableType,
    mappableId: number,
    targetType: ConvertibleMappableType,
    mapObject: MapObject
): Promise<MappableConversionResult> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/mappable_conversions`;

    return plotFetch(
        url,
        {
            method: "POST",
            body: JSON.stringify({
                mappable_type: mappableType,
                mappable_id: mappableId,
                target_type: targetType,
                map_object: mapObject,
            }),
        },
        true
    )
        .then((response) => response.json().then((json) => ({ ok: response.ok, json })))
        .then(({ ok, json }) =>
            ok ? { mappableType: json.mappable_type, mappableId: json.mappable_id } : { error: json.error }
        )
        .catch(() => ({ error: "The item could not be converted. Please try again." }));
}
